import { Cto, CtoSummary, RecommendationResponse } from "../cto";

export const getCtoSummaryResponseDefault = (): CtoSummary => ({
  CLOSED: 0,
  COMPLETED: 0,
  EXPIRED: 0,
  EXTENSION_REQUIRED: 0,
  LIVE: 0,
  UNDER_EVALUATION: 0,
  vessel_code: "",
});

export const getCtoSummaryMock = () => ({
  count_by_status: {
    "0": 0,
    "1": { PENDING: 0, IN_PROGRESS: 0 },
    "2": 0,
    "3": 0,
    "4": 0,
    "5": 0,
  },
});

export const getMitigationDefault = (): RecommendationResponse => ({
  recommendation: null,
  recommended_user: null,
  permanent_change: null,
  potential_consequences_changed: null,
  additional_mitigation_needed: null,
  due_date: new Date(),
  tags: null,
});

export const getCtoDefault = (): Cto => ({
  cto_code: "",
  status: 0,
  current_step: 0,
  creation_type: 1,
  sces: [],
  tags: [],
  final_date: null,
  created_at: null,
  created_by: null,
  versions: [],
  manual_close: null,
  cto_summary: "CTO Summary",
  cto_title: null,
  tag_reason: undefined,
  cto_type: "COMMON",
  deferment: null,
});
